// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ClockBricks(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ClockBricks" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C6.47714 22 2 17.5228 2 12C2 6.47717 6.47714 2 12 2C16.4776 2 20.2679 4.9429 21.5422 9H14.5V21.685C13.701 21.8906 12.8632 22 12 22ZM12.1094 13.6625V5.66248H10.1094V12.5938L6.5 15L7.60941 16.6641L12.1094 13.6625Z", fill: "currentColor" }),
            React.createElement("path", { d: "M22 10.5H16V13H22V10.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M22 14.5H16V17H22V14.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M16 18.5H22V21H16V18.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ClockBricks.js.map